import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useAuth } from '../../hooks/useAuth';
import { updateLogoutStateIfRequired } from './utils';
import { STORAGE_ITEM_PRODUCT_TOKEN } from '../../auth/sso';

export const AuthRefresh = ({ children }) => {
    const { authStore, dispatch } = useAuth();

    useEffect(() => {
        if (!authStore.loggedIn) {
            return;
        }

        const productToken = sessionStorage.getItem(STORAGE_ITEM_PRODUCT_TOKEN);
        updateLogoutStateIfRequired(productToken, dispatch);
    });

    return <>{children}</>;
};

AuthRefresh.propTypes = {
    children: PropTypes.node.isRequired
};

export default AuthRefresh;
